import chalk from 'chalk';
import * as fs from 'fs-extra';
import * as path from 'path';

export abstract class BaseCommand {
	protected cwd: string;
	protected configPath: string;
	protected userConfig: any;

	constructor(cwd?: string) {
		this.cwd = cwd || process.cwd();
		this.configPath = path.join(this.cwd, 'frame.config.js');
	}

	protected async loadUserConfig(): Promise<any> {
		if (await fs.pathExists(this.configPath)) {
			try {
				// Dynamic import for ES modules
				const config = await import(this.configPath);
				this.userConfig = config.default || config;
				return this.userConfig;
			} catch (error) {
				const errorMessage = error instanceof Error ? error.message : String(error);
				console.warn(chalk.yellow(`Warning: Could not load config from ${this.configPath}`));
				console.warn(chalk.yellow(errorMessage));
				return {};
			}
		}
		return {};
	}

	protected log(message: string): void {
		console.log(chalk.blue('[Frame]'), message);
	}

	protected logSuccess(message: string): void {
		console.log(chalk.green('[Frame]'), message);
	}

	protected logError(message: string): void {
		console.error(chalk.red('[Frame]'), message);
	}

	protected logWarn(message: string): void {
		console.warn(chalk.yellow('[Frame]'), message);
	}

	public abstract execute(...args: any[]): Promise<void>;
} 